import { createSelector } from '@ngrx/store';
import { AppState } from '../app.reducer';

export const selectDeviceState = (state: AppState) =>
  state.deviceTh;


export const selectThGroupsList = createSelector(
  selectDeviceState,
  (state) => state.thGroupsList
);
export const selectThGroupsListV2 = createSelector(
  selectDeviceState,
  (state) => state.thGroupsListV2
);
export const selectThDeviceStatus = createSelector(
  selectDeviceState,
  (state) => state.thDeviceStatus
);
export const selectThLogLoading = createSelector(
  selectDeviceState,
  (state) => state.thLogLoading
);
export const selectThLogData = createSelector(
  selectDeviceState,
  (state) => state.thLogData
);
export const selectLoadingThLogExp = createSelector(
  selectDeviceState,
  (state) => state.loadingThLogExp
);
export const selectLoadedThLogExp = createSelector(
  selectDeviceState,
  (state) => state.loadedThLogExp
);
export const selectLogThExport = createSelector(
  selectDeviceState,
  (state) => state.logThExport
);
export const selectLoadingThGroups = createSelector(
  selectDeviceState,
  (state) => state.loadingThGroups
);
export const selectSavingThGroups = createSelector(
  selectDeviceState,
  (state) => state.savingThGroups
);
export const selectCurrentThGroupFinalUsers = createSelector(
  selectDeviceState,
  (state) => state.currentThGroupFinalUsers
);
export const selectThGroupShareInvitationRevoking = createSelector(
  selectDeviceState,
  (state) => state.thGroupShareInvitationRevoking
);
export const selectThGroupShareInvitationRevoked = createSelector(
  selectDeviceState,
  (state) => state.thGroupShareInvitationRevoked
);
export const selectThGroupRemovingSharing = createSelector(
  selectDeviceState,
  (state) => state.thGroupSharingRemoving
);
export const selectThGroupRemovedSharing = createSelector(
  selectDeviceState,
  (state) => state.thGroupSharingRemoved
);
export const selectCurrentDeviceThermo = createSelector(
  selectDeviceState,
  (state) => state.deviceThermo
);